import z from "zod";

const svixErrorTypeValues = [
  "APP_NOT_FOUND",
  "APP_CREATION_FAILED",
  "WEBHOOK_SEND_FAILED",
  "ORGANIZATION_NOT_FOUND",
] as const;

const svixErrorTypeSchema = z.enum(svixErrorTypeValues);
const SvixErrorType = svixErrorTypeSchema.enum;
type SvixErrorType = z.infer<typeof svixErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type SvixErrors =
  | {
      errorType: typeof SvixErrorType.APP_NOT_FOUND;
      data: {
        organizationId: string;
      };
    }
  | {
      errorType: typeof SvixErrorType.APP_CREATION_FAILED;
      data: {
        organizationId: string;
        organizationName?: string;
      };
    }
  | {
      errorType: typeof SvixErrorType.WEBHOOK_SEND_FAILED;
      data: {
        organizationId: string;
        eventType?: string;
      };
    }
  | {
      errorType: typeof SvixErrorType.ORGANIZATION_NOT_FOUND;
      data: {
        organizationId: string;
      };
    };

export const svixErrorDetails: Record<SvixErrorType, ErrorDetails> = {
  [SvixErrorType.APP_NOT_FOUND]: {
    sentryDescription: "Svix app not found for organization",
  },
  [SvixErrorType.APP_CREATION_FAILED]: {
    sentryDescription: "Failed to create Svix app for organization",
  },
  [SvixErrorType.WEBHOOK_SEND_FAILED]: {
    sentryDescription: "Failed to send webhook via Svix",
  },
  [SvixErrorType.ORGANIZATION_NOT_FOUND]: {
    sentryDescription: "Organization not found when accessing Svix",
  },
};
